import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BuyTicketHeader from "../components/BuyTicket/BuyTicketHeader";
import BuyTicketHeaderTwoWay from "../components/BuyTicket/BuyTicketHeaderTwoWay";
import BusSeats from "../components/BuyTicket/BusSeats/BusSeats";
import BusSeatsTwoWay from "../components/BuyTicket/BusSeatsTwoWay/BusSeatsTwoWay";
import TicketInformationForm from "../components/BuyTicket/TicketInformationForm";
import BuyTicketPriceCard from "../components/BuyTicket/BuyTicketPriceCard";
import BuyTicketButton from "../components/BuyTicket/BuyTicketButton";
import ExpireSchedule from "../components/BuyTicket/ExpireSchedule";
import ShowSchedulesStopsModal from "../components/BuyTicket/ShowSchedulesStops/ShowSchedulesStopsModal";
import ChooseTwoWayBackHour from "../components/BuyTicket/ChooseTwoWayBackHour";
import "../components/BuyTicket/index.css";

const BuyTicketPage = () => {
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [selectedTwoWaySeat, setSelectedTwoWaySeat] = useState(null);

  const [personName, setPersonName] = useState("");
  const [personEmail, setPersonEmail] = useState("");
  const [personPhone, setPersonPhone] = useState("");
  const [priceType, setPriceType] = useState("");
  const [priceId, setPriceId] = useState("");
  const [priceTwoWay, setPriceTwoWay] = useState("");
  const [priceAmount, setPriceAmount] = useState("");
  const [ticketName, setTicketName] = useState("");
  const [checkEmptyInput, setCheckEmptyInput] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");

  const {
    schedules,
    schedulesId,
    schedulesTwoWay,
    schedulesTwoWayId,
    openChooseTwoWayScheduleModaL,
  } = useSelector((state) => state.schedulesReducer);

  const { showTwoWayDateInput } = useSelector(
    (state) => state.destinationReducer
  );

  useEffect(() => {
    const storedInfo = localStorage.getItem("personalInfo");
    if (storedInfo) {
      const { name, email, phone } = JSON.parse(storedInfo);
      setPersonName(name);
      setPersonEmail(email);
      setPersonPhone(phone);
    }
  }, []);

  const getExactSchedule = schedules?.find(
    (schedule) => schedule?.kursId === schedulesId
  );

  return (
    <>
      {getExactSchedule ? (
        <>
          {showTwoWayDateInput ? (
            <BuyTicketHeaderTwoWay />
          ) : (
            <BuyTicketHeader />
          )}

          <ShowSchedulesStopsModal />
          {showTwoWayDateInput && openChooseTwoWayScheduleModaL && (
            <ChooseTwoWayBackHour />
          )}
          <div className="buy-ticket-main-container">
            <div className="buy-ticket-container">
              <div className="buy-ticket-container-item">
                <BuyTicketPriceCard
                  checkEmptyInput={checkEmptyInput}
                  priceType={priceType}
                  priceId={priceId}
                  setPriceType={setPriceType}
                  setPriceId={setPriceId}
                  setPriceAmount={setPriceAmount}
                  setTicketName={setTicketName}
                  setPriceTwoWay={setPriceTwoWay}
                />
              </div>
              <div className="buy-ticket-container-item">
                <BusSeats
                  schedules={schedules}
                  schedulesId={schedulesId}
                  selectedSeat={selectedSeat}
                  setSelectedSeat={setSelectedSeat}
                  checkEmptyInput={checkEmptyInput}
                  setCheckEmptyInput={setCheckEmptyInput}
                />
              </div>
              {showTwoWayDateInput && (
                <div className="buy-ticket-container-item buy-seats-two-way-container">
                  <BusSeatsTwoWay
                    schedules={schedulesTwoWay}
                    schedulesId={schedulesTwoWayId}
                    selectedSeat={selectedTwoWaySeat}
                    setSelectedSeat={setSelectedTwoWaySeat}
                    checkEmptyInput={checkEmptyInput}
                    setCheckEmptyInput={setCheckEmptyInput}
                  />
                </div>
              )}
              <div className="buy-ticket-container-item">
                <TicketInformationForm
                  setPersonName={setPersonName}
                  setPersonEmail={setPersonEmail}
                  setPersonPhone={setPersonPhone}
                  setPriceType={setPriceType}
                  setPriceId={setPriceId}
                  checkEmptyInput={checkEmptyInput}
                  personName={personName}
                  personEmail={personEmail}
                  personPhone={personPhone}
                  priceType={priceType}
                  priceId={priceId}
                  errorEmail={errorEmail}
                  setErrorEmail={setErrorEmail}
                  setCheckEmptyInput={setCheckEmptyInput}
                />
                <BuyTicketButton
                  priceTwoWay={priceTwoWay}
                  selectedSeat={selectedSeat}
                  selectedTwoWaySeat={selectedTwoWaySeat}
                  personName={personName}
                  personEmail={personEmail}
                  personPhone={personPhone}
                  priceType={priceType}
                  priceId={priceId}
                  priceAmount={priceAmount}
                  ticketName={ticketName}
                  checkEmptyInput={checkEmptyInput}
                  setCheckEmptyInput={setCheckEmptyInput}
                  errorEmail={errorEmail}
                  setSelectedSeat={setSelectedSeat}
                  setSelectedTwoWaySeat={setSelectedTwoWaySeat}
                  setPersonName={setPersonName}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <ExpireSchedule />
      )}
    </>
  );
};

export default BuyTicketPage;
